import type { Topic } from '@mira/clients-shared';
import { formatDateLabel } from '../../screens/shared.js';
import { MiraIcon } from '../primitives/index.js';

export function TopicRow(props: { topic: Topic; href: string }) {
  const topic = props.topic;
  return (
    <a className="mira-topic-visual-row" href={props.href}>
      <span className="mira-topic-visual-icon" aria-hidden="true"><MiraIcon name="semantic.topic" /></span>
      <div><h2>{topic.title}</h2>{topic.category_label ? <p className="mira-topic-category">{topic.category_label}</p> : null}{topic.summary ? <p>{topic.summary}</p> : null}</div>
      <div className="mira-topic-row-meta"><small>{formatDateLabel(topic.last_activity_at ?? topic.updated_at)}</small></div>
      <span className="mira-row-chevron" aria-hidden="true"><MiraIcon name="action.next" /></span>
    </a>
  );
}
